export enum Browser {
    Chrome = 'Chrome',
    Firefox = 'Firefox',
    Edge = 'Edge',
    Safari = 'Safari',
}
